import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLanguage } from "../i18n/LanguageContext";

export default function ProofOutcomes() {
  const { t, copy } = useLanguage();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
      delay: 100,
      once: true,
    });
  }, []);

  return (
    <section className="amgProof" id="proof__outcomes" data-aos="fade-up">
      <div className="amgProofInner">
        <p className="amgProofEyebrow">{t("proof.eyebrow")}</p>
        <h2 className="amgProofHead">
          {t("proof.headBefore")}
          <span className="amg-accent">{t("proof.headAccent")}</span>
        </h2>
        <p className="amgProofLead">{t("proof.lead")}</p>

        <ul className="amgProofGrid">
          {copy.proof.items.map((item) => (
            <li key={item.title} className="amgProofCard">
              <h3 className="amgProofCardTitle">{item.title}</h3>
              <p className="amgProofCardBody">{item.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
